import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useI18n } from '@/i18n/useI18n'
import { useUserStore } from '@/store'
import { useThemeEffect } from '@/features/settings/theme'

export function RequireSession() {
  const { t } = useI18n()
  useThemeEffect()
  const authStatus = useUserStore((state) => state.authStatus)
  const location = useLocation()

  if (authStatus === 'initializing') {
    return (
      <div className="grid min-h-dvh place-items-center bg-background p-6">
        <p className="text-sm text-muted-foreground">{t('auth.restoringSession')}</p>
      </div>
    )
  }

  if (authStatus === 'anonymous') {
    const from = `${location.pathname}${location.search}${location.hash}`
    return <Navigate to="/ingresar" replace state={{ from }} />
  }

  return <Outlet />
}
